import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {firstNestedSymbolControl, hasGruppeTechnischeSteuerung, IBANControl} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {EventService} from '../../../services/event.service';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {inOutAnimation, ISymbol} from '@lv1871/core';
import {EnumGruppeTechnischeSteuerung, hasAvvEinwilligung} from '../../../models/enumGruppeTechnischeSteuerung';
import {StageConfigService} from '../../../services/stage-config.service';

@Component({
    selector: 'lv-iban',
    templateUrl: './iban.component.html',
    styleUrls: ['./iban.component.scss'],
    animations: [inOutAnimation],
    standalone: false
})
export class IbanComponent implements OnInit, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public isDisabled: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public _ibanDisplayString: string;
  public bankname: string;
  public autocomplete: string;
  private _uiArtefakt: IBANControl;

  constructor(private cd: ChangeDetectorRef, private _validationService: ValidationService,
              private _uiUpdateService: UiUpdateService, private _shellConfigService: ShellConfigService,
              private _eventService: EventService, private _stageConfigService: StageConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): IBANControl {
    return this._uiArtefakt;
  }

  get ibanDisplayString(): string {
    return this._ibanDisplayString;
  }

  @Input() set uiArtefakt(uiArtefakt: IBANControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED ||
        !hasAvvEinwilligung(hasGruppeTechnischeSteuerung(
            this.uiArtefakt, EnumGruppeTechnischeSteuerung.AVVEINWILLIGUNG),
            this._eventService.avvEinwilligungImAntrag$.getValue(),
            this._eventService.vermittlerdatenFuerAvvGesetzt$.getValue());
    this.ibanDisplayString = this._transformIban(this._uiArtefakt.WertEingabe);
    this.bankname = uiArtefakt.Bankname;
    this.cd.detectChanges();
  }

  set ibanDisplayString(iban: string) {
    this._ibanDisplayString = iban;
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
  }

  public ngAfterViewInit() {
    this.cd.detectChanges();
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public changeValue(value: any, isValid: boolean) {
    if (!value && !this.uiArtefakt.WertEingabe || !!value && value.replace(/\s/g, '').toUpperCase() === this.uiArtefakt.WertEingabe + '') {
      return;
    }
    this.bankname = null;
    if (!value) {
      this.uiArtefakt.WertEingabe = null;
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
      return;
    }
    if (isValid) {
      this.uiArtefakt.WertEingabe = value.replace(/\s/g, '').toUpperCase();
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
    }
  }

  onBlur() {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  private _transformIban(value: string): string {
    if (!value) {
      return value;
    }
    const checkBlanks = new RegExp(/\s/g);
    if (checkBlanks.test(value)) {
      value = value.replace(checkBlanks, '');
    }
    let result = '';
    while (value.match(/([a-zA-Z0-9]{4})/)) {
      result += value.substring(0, 4) + ' ';
      value = value.substring(4);
    }
    return result + value;
  }
}
